// Central React Query cache-key factory. Invalidation matches by prefix, so
// invalidating `queryKeys.records` also drops every `recordsList(...)` query.
export const queryKeys = {
  me: ["me"] as const,
  groups: ["groups"] as const,
  defaultGroupCategories: ["groups", "default-categories"] as const,
  members: (groupId: string) => ["members", groupId] as const,
  invites: (groupId: string) => ["invites", groupId] as const,
  invite: (code: string) => ["invite", code] as const,
  accounts: (groupId: string) => ["accounts", groupId] as const,
  categories: (groupId: string) => ["categories", groupId] as const,
  tags: (groupId: string) => ["tags", groupId] as const,
  popularTags: (groupId: string, categoryId: string) =>
    ["popular-tags", groupId, categoryId] as const,
  currencies: (groupId: string) => ["currencies", groupId] as const,
  supportedCurrencies: ["supported-currencies"] as const,
  recurringPayments: (groupId: string) =>
    ["recurring-payments", groupId] as const,
  summary: ["summary"] as const,
  overview: (groupId: string) => ["overview", groupId] as const,
  records: ["records"] as const,
  recordsList: (groupId: string, filters: unknown) =>
    ["records", groupId, filters] as const,
  deletedRecords: ["deleted-records"] as const,
  deletedRecordsList: (groupId: string, filters: unknown) =>
    ["deleted-records", groupId, filters] as const,
  deletedRecordsPreview: (groupId: string) =>
    ["deleted-records", groupId, "preview"] as const,
  statistics: (groupId: string, filters: unknown) =>
    ["statistics", groupId, filters] as const,
  statisticsRoot: (groupId: string) => ["statistics", groupId] as const,
  statisticsOperations: (groupId: string, filters: unknown) =>
    ["statistics-operations", groupId, filters] as const,
  statisticsOperationsRoot: (groupId: string) => ["statistics-operations", groupId] as const,
  record: (groupId: string, transactionId: string) =>
    ["record", groupId, transactionId] as const,
  importBatches: (groupId?: string) =>
    groupId === undefined
      ? (["import-batches"] as const)
      : (["import-batches", groupId] as const),
  importBatch: (groupId: string, batchId: string) =>
    ["import-batch", groupId, batchId] as const,
  importBatchStatus: (groupId: string, batchId: string) =>
    ["import-batch-status", groupId, batchId] as const,
  importInstruction: (provider: string) =>
    ["import-instruction", provider] as const,
  debugCategoryCache: (groupId: string) =>
    ["debug-category-cache", groupId] as const,
  debugTagCategoryStats: (groupId: string) =>
    ["debug-tag-category-stats", groupId] as const,
  transferLinkRules: (groupId: string) =>
    ["transfer-link-rules", groupId] as const,
  transferLinkSuggestions: (groupId: string) =>
    ["transfer-link-suggestions", groupId] as const,
  linkCandidates: (groupId: string, transactionId?: string) =>
    ["link-candidates", groupId, transactionId] as const,
  mcpTokens: ["mcp-tokens"] as const,
  exchangeRateProvider: ["exchange-rate-provider"] as const,
  tips: ["tips"] as const,
  currencyConversion: (...parts: unknown[]) =>
    ["currency-conversion", ...parts] as const,
  backoffice: (section: string) => ["backoffice", section] as const,
  backofficeCurrencyMetadata: (code: string) =>
    ["backoffice", "currency-metadata", code] as const,
};
